import auth from '../auth_api/auth'
import session from '../auth_api/session'

const TOKEN_STORAGE_KEY = 'TOKEN_STORAGE_KEY'

export default {
  namespaced: true,
  state: {
    is_token: false,
    clearUser: {
      username: '',
      groups: []
    },
    user: {
      username: '',
      department: {},
      groups: []
    },
    clearDependentDepartments: [
      {
        'ogrn': '',
        'name_short': '',
        'chief': null
      }
    ],
    dependentDepartments: [
      {
        'ogrn': '',
        'name_short': '',
        'chief': null
      }
    ]

  },
  mutations: {
    setToken (state, token) {
      localStorage.setItem(TOKEN_STORAGE_KEY, token)
      session.defaults.headers.Authorization = `Token ${token}`
      state.is_token = true
    },
    removeToken (state) {
      localStorage.removeItem(TOKEN_STORAGE_KEY)
      delete session.defaults.headers.Authorization
      state.is_token = false
    },
    setUser (state, payload) {
      state.user = payload
    },
    clearUser (state, payload) {
      state.user = state.clearUser
    },
    setDependentDepartments (state, payload) {
      state.dependentDepartments = []
      state.dependentDepartments.push(
        {
          'ogrn': payload.department.ogrn,
          'name_short': payload.department.name_short,
          'chief': true
        })
      for (let row in payload.department.dependent_departments) {
        state.dependentDepartments.push(
          {
            'ogrn': payload.department.dependent_departments[row].ogrn,
            'name_short': payload.department.dependent_departments[row].name_short,
            'chief': false
          })
      }
    },
    clearDependentDepartments (state, payload) {
      state.dependentDepartments = state.clearDependentDepartments
    }
  },
  actions: {
    login ({ commit }, { username, password }) {
      return auth.login(username, password)
    },
    logout ({ commit }) {
      return auth.logout()
        .finally(() => {
          commit('removeToken')
          commit('clearUser')
          commit('clearDependentDepartments')
        })
    },
    user ({ commit, getters, dispatch }) {
      return new Promise((resolve, reject) => {
        if (getters.isAuthenticated) {
          commit('common/clearError', null, { root: true })
          commit('common/pushLoading', 'user', { root: true })
          auth.user()
            .then(response => {
              commit('setUser', response.data)
              commit('setDependentDepartments', response.data)
              commit('common/popLoading', 'user', { root: true })
              resolve()
            })
            .catch(e => {
              dispatch('common/setError', e, { root: true })
              commit('common/popLoading', 'user', { root: true })
              reject(e)
            })
        } else {
          resolve()
        }
      })
    },
    initialize ({ commit }) {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem(TOKEN_STORAGE_KEY)
        if (token) {
          commit('setToken', token)
        } else {
          commit('removeToken')
        }
        resolve()
      })
    }
  },
  getters: {
    isAuthenticated (state) {
      return state.is_token
    },
    user (state) {
      return state.user
    },
    dependentDepartments (state) {
      return state.dependentDepartments
    },
    groupAccessAllowed: (state) => (nameGroup) => {
      return state.user.groups.filter(group => nameGroup.includes(group)).length > 0
    },
    getDependentDepartments: (state) => (ogrn) => {
      let dependentDepartment = { 'name_short': '' }
      for (let i in state.dependentDepartments) {
        if (state.dependentDepartments[i]['ogrn'] === ogrn) {
          dependentDepartment = state.dependentDepartments[i]
          break
        }
      }
      return dependentDepartment
    }
  }
}
